var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"white-frame-2 no-border-radius"},[_vm._l((_vm.allData),function(item,index){return _c('PrintPatientSection',{key:index,attrs:{"title":item.title,"data":item.data}})}),_vm._v(" "),_c('PrintPatientTabularSection',{attrs:{"data":_vm.filtered_appointments}})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-606f64da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Patient/PrintPreview.vue
// module id = null
// module chunks = 